import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {sharingPageReady} from "../../../actions/profileActions";
import './index.css';

function Support () {

    const profile = useSelector(state => state.profileReducer.getProfile);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(sharingPageReady(true));
    }, [dispatch]);

    return (
        <iframe title="Contact Support form" className="support"
                src={`https://forms.zohopublic.com/stefnewland/form/CustomerSupportForm/formperma/g1U0Tws4TlaDzRX1swTV96UHb3ss524rovtwasjCGJo?SingleLine7=${profile.name}&email=${profile.email}&phone=${profile?.details?.phoneNumbers?.[0]?.number ?? ''}`}/>
    )
}

export default Support;